<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">Dodaj Partnera</v-flex>

    <v-layout column>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex pr-2 xs6>
            <w-schema :model="$schema.partner.email">
              <v-text-field name="email" :label="$schema.partner.email.$schema.title" />
            </w-schema>
          </v-flex>

          <v-flex pr-2 xs6>
            <w-schema :model="$schema.partner.name">
              <v-text-field name="name" label="Nazwa Partnera *" />
            </w-schema>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ProfileType } from '@witkac/kartamiejska-shared';
import { schemaMixin, WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import { CONST } from '@/const';
import HtmlEditor from '@/components/forms/HtmlEditor';
import ImagesList from '@/components/forms/ImagesList';
import SingleImage from '@/components/forms/SingleImage';
import TerytForm from '@/components/forms/TERYTForm';
import Modal from '@/components/material/Modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/partner_registration.schema';

const emptyData = {
  login: '',
  profile: {
    type: ProfileType.PARTNER,
    email: '',
    firstName: '',
    lastName: ''
  },
  partner: {
    name: '',
    email: '',
    website: '',
    description: '',
    terc: CONST.terc,
    woj: CONST.woj,
    pow: CONST.pow,
    gmi: CONST.gmi,
    simc: CONST.simc,
    postalCode: CONST.postalCode,
    city: '',
    street: '',
    ulic: '',
    mainImage: null,
    images: '',
    descriptionShort: ''
  }
};



// @vuese
// Modal dodawania Partnera
// @group Partners
export default {
  components: { ImagesList, HtmlEditor, Modal, SingleImage, WSchema, TerytForm },
  mixins: [schemaMixin, notificationsMixin],
  schema,
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      model: {
        login: emptyData.login,
        profile: { ...emptyData.profile },
        partner: { ...emptyData.partner }
      },
      profile: { ...emptyData.profile },
      partner: { ...emptyData.partner }
    };
  },
  methods: {
    // @vuese
    // Potwierdzenie zamknięcia formularza w przypadku zmian
    close() {
      if (this.$schema.$dirtyList().length !== 0) {
        this.$store.dispatch('showConfirmDialog');
      } else {
        this.closeModal();
      }
    },
    // @vuese
    // Funkcja emituje event `close` do zamknięcia modalu
    closeModal() {
      // Zamyka modal
      this.$emit('close');
    },
    // @vuese
    // Metoda czyści pola formularza
    clearForm() {
      this.$schema.$setData({
        login: emptyData.login,
        profile: { ...emptyData.profile },
        partner: { ...emptyData.partner }
      });
    },
    // @vuese
    // Metoda zapisuje Partnera
    save() {
      if (!this.$schema.$validateAll().length) {
        this.$emit('save', this.model);
        this.closeModal();
      } else {
        this.notifyError('Błędnie wypełniony formularz');
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.clearForm();
      }
    }
  }
};
</script>
